import {} from "@mui/material";
import type React from "react";
import type { MasterDataVehicleCreatePageProps } from "../model";
import { MasterDataVehicleCreateInProgress } from "./in-progress";
import { MasterDataVehicleDetailPreview } from "./preview";

export const MasterDataVehicleCreatePageUi: React.FC<
  MasterDataVehicleCreatePageProps
> = (props) => {
  if (props.previewValues) {
    return <MasterDataVehicleDetailPreview {...props} />;
  }
  return <MasterDataVehicleCreateInProgress {...props} />;
};
